function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgMoney = function SvgMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M10.719 12.874h2.552c1.046 0 1.89.824 1.89 1.845 0 1.02-.844 1.845-1.89 1.845H8.678a.907.907 0 00-.914.893c0 .49.412.893.914.893h2.402v1.757c0 .49.412.893.915.893a.907.907 0 00.915-.893V18.35h.371c2.05 0 3.719-1.63 3.719-3.631 0-2.003-1.668-3.632-3.719-3.632H10.73c-1.046 0-1.89-.824-1.89-1.845 0-1.02.844-1.845 1.89-1.845h4.512a.907.907 0 00.915-.893.907.907 0 00-.915-.893H12.92V3.893A.907.907 0 0012.005 3a.907.907 0 00-.915.893v1.728h-.371C8.669 5.62 7 7.25 7 9.25c.01 1.993 1.678 3.623 3.719 3.623z"
  }));
};
SvgMoney.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgMoney.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgMoney;